import * as React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Fade from '@mui/material/Fade';

const SimpleSuccessSpinner = ({ open, handleClose, message }) => {
  return (
    <Modal
      open={Boolean(open)}
      onClose={handleClose}
      closeAfterTransition
      disableRestoreFocus
      sx={{
        zIndex: 99999, // Asegurar que quede por encima de modales
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(15, 23, 42, 0.45)',
          backdropFilter: 'blur(3px)',
          WebkitBackdropFilter: 'blur(3px)',
          transition: 'all 0.2s ease',
        }
      }}
    >
      <Fade in={Boolean(open)} timeout={200}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 'clamp(260px, 80vw, 340px)',
            maxWidth: '90vw',
            bgcolor: '#ffffff',
            borderRadius: 'clamp(14px, 1.5vw, 20px)',
            border: '1px solid #e2e8f0',
            boxShadow: '0 25px 50px -12px rgba(15, 23, 42, 0.25), 0 0 0 1px rgba(226, 232, 240, 0.8)',
            p: 'clamp(18px, 2.5vw, 28px)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            outline: 'none',
          }}
        >
          {/* Spinner Premium con Doble Anillo */}
          <Box sx={{ position: 'relative', display: 'inline-flex', mb: 'clamp(12px, 1.5vw, 16px)' }}>
            <CircularProgress
              variant="determinate"
              value={100}
              size={44}
              thickness={4}
              sx={{ color: '#e2e8f0' }}
            />
            <CircularProgress
              variant="indeterminate"
              disableShrink
              size={44}
              thickness={4}
              sx={{
                color: '#0655A5',
                position: 'absolute',
                left: 0,
                strokeLinecap: 'round',
                animationDuration: '800ms',
              }}
            />
          </Box>

          {message && (
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: 'clamp(0.82rem, 0.78rem + 0.15vw, 0.92rem)',
                color: '#0f172a',
                lineHeight: 1.35,
                letterSpacing: '-0.01em',
              }}
            >
              {message}
            </Typography>
          )}

          <Typography
            sx={{
              mt: 0.4,
              fontSize: 'clamp(0.68rem, 0.65rem + 0.08vw, 0.74rem)',
              color: '#64748b',
              fontWeight: 500,
            }}
          >
            Por favor espera un momento...
          </Typography>
        </Box>
      </Fade>
    </Modal>
  );
};

export default SimpleSuccessSpinner;